import { Moment } from 'moment';

/**
 * A validade do token no formato que o serviço aceita (MV2-1706).
 *
 * Duas coisas, e as duas foram confirmadas por HTTP contra o serviço:
 *
 * 1. O `Z` no fim é **obrigatório e literal**. O desserializador global usa o padrão
 *    `yyyy-MM-dd'T'HH:mm:ss'Z'` (JacksonConfiguration), então `2026-09-01T00:00:00` falha no
 *    índice 19 e a criação devolve **500**. O modal mandava exatamente isso: token com data de
 *    validade nunca era criado, só a opção "não expira" funcionava.
 *
 * 2. Vai o **fim do dia escolhido**, e não a meia-noite. O serviço recusa validade que não seja
 *    futura (`!expiresAt.isAfter(LocalDateTime.now())`), então escolher hoje com 00:00:00 seria
 *    recusado — e "expira em 01/09" significa "vale até o fim do dia 01/09", não "morre à
 *    meia-noite que abre o dia".
 *
 * O `Z` aqui não é declaração de fuso: o serviço compara com `LocalDateTime.now()`, hora local do
 * servidor. É exigência de formato desta API, e é por isso que a hora local vai sem conversão.
 */
export const tokenExpiryPayload = (expiresAt: Moment | null): string | null =>
  expiresAt ? `${expiresAt.endOf('day').format('YYYY-MM-DDTHH:mm:ss')}Z` : null;
